import styled from 'styled-components';

export const BookNowBtn = styled.button`
    width: ${p => p.btnWidth ? p.btnWidth : ''};
    height: ${p => p.btnHeight ? p.btnHeight : '3.3rem'};
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    border-radius: 0.4rem;
    background-color: ${p => p.btnBgColor ? p.btnBgColor : '#ff6d38'};
    font-family: 'Rubik';
    font-size: ${p => p.fontSize ? p.fontSize : '1.4rem'};
    color: ${p => p.btnColor ? p.btnColor : '#fff'};
    font-weight: 600;
    margin: ${p => p.margin ? p.margin : ''};
    padding: ${p => p.padding ? p.padding : '0 4.3rem'};
    outline: 0;
    border: ${p => p.btnBorder ? p.btnBorder : '0'};
    cursor: pointer;
`;